import { render, staticRenderFns } from "./HowItWorks.vue?vue&type=template&id=655bc193&scoped=true&"
import script from "./HowItWorks.js?vue&type=script&lang=js&"
export * from "./HowItWorks.js?vue&type=script&lang=js&"
import style0 from "./HowItWorks.scss?vue&type=style&index=0&id=655bc193&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655bc193",
  null
  
)

export default component.exports